module.exports = __webpack_public_path__ + "img/32.2b96a870.jpg";